import React, { Component } from 'react';
import './download.css';

class download extends Component {
  constructor(props){
    super(props)
    this.state={
      intro:[{
        text:"INTELLIGENT"
      },{
        text:"PORTABLE"
      },{
        text:"ACCURATE"
      }]
    }
  }
  componentDidMount(){
    let header = document.getElementsByClassName('App-header')[0];
    header.style.display="none";
    let bottom = document.getElementsByClassName('bottom')[0];
    bottom.style.display="none";
    let shenqing = document.getElementsByClassName('shenqing')[0];
    shenqing.style.display="none";
    let banquan = document.getElementsByClassName('banquan')[0];
    banquan.style.display="none";
  }
  render() {
    return (
      <div className="App-bg">
        <div className="download">
          <img src={require('./image/pic.png')} className="logo"/>
          <div className="box01">
            {
              this.state.intro.map((item) =>{
                return(
                  <div className="intro">
                    {item.text}
                  </div>
                )
              })
            }
          </div>
          <div className="intro01">
              create a revolutionary way of body measuring
          </div>
          <div className="botton ios">
            <img src={require('./image/pingguo.png')} className="system" />
            <div>   
              iOS version is coming soon
            </div>
          </div>
          <a href="https://www.pgyer.com/xFnG" className="botton android">
            <img src={require('./image/changyonglogo37.png')} className="system" />
            <div>   
              Download Android Demo    
            </div>
          </a>
          <div className="copyright">
            Copyright Belongs to QingDao Red Creation Technology.
          </div>
        </div>
      </div>
    );
  }
}

export default download;


// WEBPACK FOOTER //
// ./src/download.js